import { render, staticRenderFns } from "./TransferInventory.vue?vue&type=template&id=1ce97645&scoped=true"
import script from "./TransferInventory.vue?vue&type=script&lang=js"
export * from "./TransferInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce97645",
  null
  
)

export default component.exports